module.exports = __webpack_public_path__ + "2024611:ed75de4ab11883afa87d/img/hero_image@2x.362b064.png";